<template>
    <div class="steam" v-if="sitedata">
        <div class="title">
            <span>{{sitedata.SiteNo}} &lt; {{sitedata.SiteName}}&gt;</span>
        </div>
        <!-- 折线图 -->
        <div :class="dataChartClass"></div>
    </div>
</template>
<script>
// 表格参数
const chartOption = {
    //数据提示框
    tooltip: {
        trigger: 'axis',
        textStyle: {
            fontSize: 10
        }
    },
    dataset: {
        // 这里指定了维度名的顺序，从而可以利用默认的维度到坐标轴的映射。
        // 如果不指定 dimensions，也可以通过指定 series.encode 完成映射，参见后文。
        dimensions: ['RecordTime', 'DifPress','InsFlux'],
    }, // 数据集配置
    //区域缩放，
    dataZoom: {
        type: 'inside',//内置于坐标系中 ，在坐标系上通过鼠标拖拽，滚轮，单指拖拽，双指缩放
    },
    // 多个y轴要留出空间
    grid:{
        right: '25%',
        left:'8%'
    },
    //图例
    legend: {
        itemGap:15, //图例之间的间隔
        itemWidth:10,
        itemHeight:8,
        padding:2,
        data: [], // 图例数组
        selected: {},// 选中的图例数组
    },
    calculable : true,
    xAxis: {
        type: 'time',//注意：数据类型不能为category，否则数据缺少时，不会自动留出空间
        splitLine: {
            show: false
        },// 是否显示网格线
        axisLabel: {
            textStyle: {
                fontSize: 12//在手机端，字体比较大，看得清楚
            }
        }
    },
    yAxis : [],
    series : []
};

// 引入echarts图表
import echarts from 'echarts/lib/echarts';

export default {
    name:"steam",
    props:['sitedata'],
    data(){
        return {
            echartsObject:null, // echart对象
        }
    },
    mounted(){
        this.$nextTick(()=>{
            // 创建图表
            // this.createChart();
        })
    },
    watch:{
        sitedata:{
            handler:function(newValue){
                if(newValue.historychart){
                    this.createChart();
                }
            },
            deep:true
        }
    },
    computed:{
        // 动态配置图表的类名，方面echarts初始化
        dataChartClass:function(){
            return ['chart','chart_'+(this.sitedata.SiteNo?this.sitedata.SiteNo:"")];
        },
        // 获取用户配置中的chart_history，根据chart_history进行折线的绘制
        chart_history:function(){
            let configList=this.$store.getters.configList;
            let chart_history=configList.chart_history||{};
            return chart_history;
        }
    },
    methods:{
        // 创建图表
        createChart(){
            // 获取dom节点
            let chartClassName='chart_'+this.sitedata.SiteNo;
            let eleDom=document.getElementsByClassName(chartClassName)[0];
            if(!eleDom||!this.sitedata){
                return;
            }

            // 处理数据,创建echarts需要的dataSet数据集
            let historyData=this.sitedata.historychart;
            let dataSource=[]; // 数据集的source属性
            for(let dataItemKey in historyData){
                let dataItem=historyData[dataItemKey][this.sitedata.SiteNo];
                dataSource.push(dataItem);
            }
            // 设置
            chartOption.dataset.source=dataSource;

            let historyChartDimension=['RecordTime'];// 数据集的dimension属性
            let legendSelected={}; // 图例的选中状态

            // // 生成Y轴
            let chartConfig=this.chart_history[this.sitedata.MediumType]; //用户配置

            // 清空数据
            chartOption.legend.data=[];
            chartOption.yAxis=[];
            chartOption.series=[];

            let itemIndex=0; // 当前坐标轴的序号
            for(let itemName in chartConfig){
                let chineseName=chartConfig[itemName]; //字段的中文名
                // 设置dataSet的维度
                historyChartDimension.push(itemName);
                // 图例增加
                chartOption.legend.data.push(chartConfig[itemName]);
                // 默认选中的序列,第一列显示，其余不显示
                if(itemIndex==0){
                    chartOption.legend.selected["\""+chineseName+"\""]=true;
                }else{
                    chartOption.legend.selected["\""+chineseName+"\""]=false;
                }
                legendSelected[chineseName] = (itemIndex == 0 ? true : false);//第一个数据默认是选中，其他数据默认非选中


                // 设置y轴的值
                let yAxis={
                    type: 'value',
                    name:chineseName,
                    nameLocation:"center",
                    nameGap:30,
                    nameRotate:90,
                    nameTextStyle:{
                        fontSize: 14,
                    },
                    offset:50* (itemIndex < 1 ? itemIndex : itemIndex - 1),

                    //默认以千分位显示，不想用的可以在这加一段
                    axisLabel : {   //调整左侧Y轴刻度， 直接按对应数据显示
                        show:true,
                        showMinLabel:true,
                        showMaxLabel:true,
                        formatter: function (value) {
                            return value;
                        }
                    }
                };
                // 增加yAxis
                chartOption.yAxis.push(yAxis);

                // 设置series
                let serie={
                    name:chineseName,
                    type:'line',
                    smooth: true,
                    showSymbol:false,
                    yAxisIndex:itemIndex,
                    encode: {
                        // 映射数据集中的哪个字段
                        y: itemName
                    },
                    splitLine:{
                        show:true
                    },
                };
                // 设置到对应的列上去
                chartOption.series.push(serie);

                // index值增加
                itemIndex++;
            }

            // 修改维度
            chartOption.dataset.dimensions=historyChartDimension;
            // 设置图例的选中状态，第一显示，其余的不选中
            chartOption.legend.selected=legendSelected;
            // 初始化图表
            this.echartsObject=echarts.init(eleDom);
            this.echartsObject.setOption(chartOption, true);
        },

        // 销毁图表
        disposeEchart(){
            if(this.echartsObject){
                this.echartsObject.clear();
                this.echartsObject.dispose();
            }
        }
    }
}
</script>
<style lang="scss">
.steam{
    min-height: 300px;
    background:#fff;
    position: relative;
    padding:10px;
    display: flex;
    flex-direction:column;

    /**图表表头 */
    .title{
        flex: 0 0 auto;
        font-size: 14px;
    }

    /**内容 */
    .chart{
        position: relative;
        display: flex;
        flex-grow: 1;        
    }
}
</style>